import React, { useContext } from 'react'
import { array, func } from 'prop-types'

import { pricify } from 'utils/pricify'
import { availableForSale } from 'utils/products'

import NativeAuthContext from 'components/NativeAuth'
import CheckoutContext from 'contexts/Checkout'
import BuySection from 'components/buy/BuySection'
import Addon from 'components/buy/Addon'

const BuyAccessories = ({ accessories, handleAccessoryQuantityChange }) => {
  const { products } = useContext(CheckoutContext)
  const { province } = useContext(NativeAuthContext)

  if (!accessories || accessories.length === 0) return null

  return (
    <BuySection id="add-accessories">
      {accessories.map((accessory, i) => {
        const variant = accessory.variants[0]

        const fetchedProduct = products.find(p => accessory.id.includes(p.shopifyGid))

        if (fetchedProduct && !fetchedProduct?.availableProvinces.includes(province)) {
          return null
        }

        const isAvailableForSale = availableForSale({ variant: fetchedProduct?.variants[0], province })

        return (
          <Addon
            figure={variant.image.originalSrc}
            heading={accessory.title}
            price={pricify(accessory.priceRange.maxVariantPrice)}
            description={accessory.description || accessory.title}
            onAdd={() => {}}
            onRemove={() => {}}
            active={variant.quantity === 1}
            isAvailableForSale={isAvailableForSale}
            key={i}
            withQuantityPicker
            handleAccessoryQuantityChange={handleAccessoryQuantityChange}
            product={accessory}
          />
        )
      })}
    </BuySection>
  )
}

BuyAccessories.propTypes = {
  accessories: array,
  handleAccessoryQuantityChange: func
}

export default BuyAccessories
